'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.courtReservation', {
        url: '/courtreservations',
        templateUrl: 'app/courtReservation/courtReservation.html',
        controller: 'CourtReservationCtrl',
      })
  });